// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"5665f6a1","703":"e5e1bc6e","787":"3a79f99b"}[chunkId] + ".chunk.js";
};